import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_ROUTES } from './constants';
import { loginGuard } from '@guards/login.guard';
import { authenticationGuard } from '@guards/authentication.guard';
import { rootGuard } from '@guards/root.guard';

const ROUTES: Routes = [
    {
        path: APP_ROUTES.Root,
        children: [],
        canActivate: [rootGuard]
    },
    {
        path: APP_ROUTES.Login,
        loadChildren: async () => import('./features/authentication').then((m) => m.AuthenticationModule),
        canActivate: [loginGuard]
    },
    {
        path: APP_ROUTES.Dashboard,
        loadChildren: async () => import('./features/dashboard').then((m) => m.DashboardModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.User,
        loadChildren: async () => import('./features/user').then((m) => m.UserModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Measurement,
        loadChildren: async () => import('./features/measurement').then((m) => m.MeasurementModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Location,
        loadChildren: async () => import('./features/location').then((m) => m.LocationModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Device,
        loadChildren: async () => import('./features/device').then((m) => m.DeviceModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Tenant,
        loadChildren: async () => import('./features/tenant').then((m) => m.TenantModule),
        canActivate: [authenticationGuard]
    },
    {
        path: APP_ROUTES.Help,
        loadChildren: async () => import('./features/help').then((m) => m.HelpModule),
        canActivate: [authenticationGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(ROUTES)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
